import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePersonResume } from '@/features/student-management/hooks/usePersonResume';
import { PersonResumeExams } from '@/features/student-management/ui/organisms/PersonResumeExams';
import { PersonResumeSummary } from '@/features/student-management/ui/organisms/PersonResumeSummary';
import { PersonResumeTemplate } from '@/features/student-management/ui/templates/PersonResumeTemplate';
import { Spinner } from '@/shared/ui/atoms';

export const Route = createFileRoute('/_authenticated/persons/$id/resume/')({
  component: PersonResumePage,
});

function PersonResumePage() {
  const { id } = Route.useParams();
  const { t } = useTranslation('personManagement');
  const { resume, isLoading } = usePersonResume(Number(id));

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-xl">
        <Spinner size="md" />
      </div>
    );
  }

  if (!resume) {
    return (
      <PersonResumeTemplate personName="">
        <p className="ts-paragraph-xs text-ctx-content-placeholder">{t('errors.notFound')}</p>
      </PersonResumeTemplate>
    );
  }

  return (
    <PersonResumeTemplate personName={resume.fullName}>
      <PersonResumeSummary resume={resume} />
      <PersonResumeExams examCourses={resume.examCourses} />
    </PersonResumeTemplate>
  );
}
